import { NavLink, Outlet } from 'react-router-dom';
import { Icon } from './Icon';
import { NAV_GROUPS } from './nav-items';
import { usePermissions } from '@/hooks/usePermissions';
import { PortfolioChip } from './PortfolioChip';
import { Topbar } from './Topbar';
import { ToastStack } from './ToastStack';

/** Каркас приложения: боковая навигация + область маршрута. */
export function AppLayout() {
  const { can } = usePermissions();

  // Недоступные разделы не показываем вовсе; группа без единого доступного
  // пункта тоже скрывается, чтобы не оставлять пустой заголовок.
  const groups = NAV_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => !item.permissions || can(...item.permissions)),
  })).filter((group) => group.items.length > 0);

  return (
    <div className="shell">
      <aside className="shell__sidebar">
        <div className="shell__brand">
          <Icon name="compass" size={17} />
          <span>Компас</span>
        </div>
        <nav className="shell__nav">
          {groups.map((group, i) => (
            <div className="shell__nav-group" key={group.title ?? i}>
              {group.title && <div className="shell__nav-title">{group.title}</div>}
              {group.items.map((item) => (
                // end: пункты меню – плоские отдельные страницы, а не разделы с
                // подстраницами, поэтому нужен точный матч (иначе, например,
                // «Все клиенты» (/clients) подсвечивается и на /clients/new).
                <NavLink key={item.to} to={item.to} end>
                  <Icon name={item.icon} size={18} />
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <PortfolioChip />
      </aside>
      <div className="shell__content">
        <Topbar />
        <main className="shell__main">
          <Outlet />
        </main>
      </div>
      <ToastStack />
    </div>
  );
}
